// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button_QI7b2","Success":"Button_Success_2dHUt","Danger":"Button_Danger_2xnhN"};